module.exports = __webpack_public_path__ + "static/media/similaritychart.492de1ac.png";